import { emailValidaotr, gstinValidator, mandatoryFieldValditor, mobileValidator } from '../../../../common/utils/validator';
import { formElement } from '../summary.constant';

export const keyForGSTFiles = {
  GST_CERTIFICATE: 'filesForGSTCerificate',
  GST_LOA: 'filesForGSTLOA'
};

export const formSchema = {
  installationAddress: '',
  delieveryDate: { ...formElement },
  gstin: { ...formElement, validator: gstinValidator },
  sezSite: false,
  dty: '',
  [keyForGSTFiles.GST_CERTIFICATE]: null,
  [keyForGSTFiles.GST_LOA]: null,
  addSiteInCharge: false,
  site: {
    contactName: { ...formElement, validator: mandatoryFieldValditor },
    mobileNumber: { ...formElement, validator: mobileValidator },
    email: { ...formElement, validator: emailValidaotr }
  }
};

export const getDefaultFiles = (fileName, documentName) => {
  const name = (fileName && fileName.split('sez/')[1]) || `doucment${documentName}`;
  return [{ name, size: 100, documentName }];
};

const setSiteInChargeDetails = (siteIncharge, isOrderConfirmation) => {
  if (isOrderConfirmation) {
    formSchema['site']['contactName'] = { ...formElement, value: siteIncharge.firstName, validator: mandatoryFieldValditor };
    formSchema['site']['mobileNumber'] = { ...formElement, value: siteIncharge.phoneNumber, validator: mobileValidator };
    formSchema['site']['email'] = { ...formElement, value: siteIncharge.email, validator: emailValidaotr };
  }
};

export const getDefaultValue = (order, isOrderConfirmation) => {
  const {
    fiscalCode,
    documents,
    siteIncharge,
    gstNumber,
    estimatedDate,
    lead: { connectivityLineItems },
    companyAddress: { addressLine1 }
  } = order;
  setSiteInChargeDetails(siteIncharge, isOrderConfirmation);
  const customerNeedDate = connectivityLineItems && connectivityLineItems?.[0].customerNeedDate;
  formSchema['installationAddress'] = addressLine1 ? addressLine1 : '';
  formSchema.delieveryDate.value = new Date(customerNeedDate || estimatedDate);
  formSchema.delieveryDate.estimatedDate = new Date(estimatedDate);
  formSchema['gstin']['value'] = (fiscalCode && fiscalCode.id ? fiscalCode.id : '') || gstNumber;
  formSchema['sezSite'] = fiscalCode && fiscalCode.sez ? fiscalCode.sez : '';
  formSchema['dty'] = fiscalCode && fiscalCode.dty ? fiscalCode.dty : '';
  formSchema['filesForGSTCerificate'] = documents && documents.SEZ && documents.SEZ.GST_CERTIFICATE ? getDefaultFiles(documents.SEZ.GST_CERTIFICATE, 'GST_CERTIFICATE') : null;
  formSchema['filesForGSTLOA'] = documents && documents.SEZ && documents.SEZ.GST_LOA_1 ? getDefaultFiles(documents.SEZ.GST_LOA_1, 'GST_LOA_1') : null;
  return formSchema;
};
